class DeleteAiProvider {
	constructor(
		public readonly accountId: number,
		public readonly providerId: number,
	) {
		Object.freeze(this);
	}
}

export default DeleteAiProvider;
